// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3NaCT","icon":"SortAdornment_icon__3PcP-","up":"SortAdornment_up__vVd23","down":"SortAdornment_down__2yUxy","active":"SortAdornment_active__3rscV"};